<script setup lang="ts">import { reactive } from '@vue/reactivity';
import { useRouter } from 'vue-router';
import EntityApi from '../../sdk/EntityApi';
import FormatHelper from '../../sdk/helpers/FormatHelper';
import Group from '../../sdk/models/Group';

const router = useRouter();  

class GroupList {
    products: Group[] = [];
}

const data = reactive(new GroupList());

const groupApi = new EntityApi('groups');
data.products = await groupApi.retrieveAll();

const createNewGroup = function() {
    router.push("/admin/groups/add");
}

const editGroup = function(product: Group) {
    router.push("/admin/groups/" + product.RowKey);
}

const deleteProduct = async function(product: Group) {
    await groupApi.delete(product);
    data.products = await groupApi.retrieveAll();
}

</script>

<template>
    <div class="form-container">

        <h3 class="form-body-title">Gruppen-Liste</h3>

        <div class="form-container-body row">
            <div class="col-xs-12">
                <div class="box-row form-container-style cardshadow">
                    <div class="list-row list-header row">
                        <div class="col-xs-2">Erstellt Am</div>
                        <div class="col-xs-3">Code</div>
                        <div class="col-xs-5">Name</div>
                        <div class="col-xs-2"></div>
                    </div>

                    <div class="list-row row" v-for="product in data.products">
                        <div class="col-xs-2">{{ FormatHelper.stringToDateTime(product.Timestamp!) }}</div>
                        <div class="col-xs-3">{{ product.RowKey }}</div>
                        <div class="col-xs-5">{{ product.Name }}</div>
                        <div class="col-xs-2 list-button-column">
                            <button type="submit" name="createNewGroup" class="buttonstyle" style="height:3rem" @click="editGroup(product)">
                                <span class="">Bearbeiten</span>
                            </button>

                            <button type="submit" name="deleteProduct" class="buttonstyle" style="height:3rem;margin-left: 1rem;" @click="deleteProduct(product)">
                                <span class="">Löschen</span>
                            </button>
                        </div>
                    </div>

                    <button type="submit" name="submit" class="buttonstyle" @click="createNewGroup" style="margin-top:3rem; margin-bottom: 1rem;">
                            <span class="">Neue Gruppe erstellen</span>
                    </button>
   
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
